module.exports = __webpack_public_path__ + "static/media/thumbsup.ec87fc45.png";